import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["icon"],
    _excluded2 = ["children", "iconSize"];

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import { ICON_SIZE } from "../../icons";
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { transitionAnimation, getRem } from "./../../core";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledButtonIcon = styled(function (_ref) {
  var icon = _ref.icon,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.cloneElement(icon, props);
}).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['iconSize'].includes(prop);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  display: inline-flex;\n  flex-shrink: 0;\n  z-index: ", ";\n\n  ", "\n"])), transitionAnimation('fill'), function (_ref2) {
  var theme = _ref2.theme;
  return theme.zIndex.buttonContent.value;
}, function (_ref3) {
  var iconSize = _ref3.iconSize;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      height: ", ";\n      width: ", ";\n    "])), getRem(iconSize === ICON_SIZE.SMALL ? ICON_SIZE.SMALL : ICON_SIZE.DEFAULT), getRem(iconSize === ICON_SIZE.SMALL ? ICON_SIZE.SMALL : ICON_SIZE.DEFAULT));
});

var ButtonIcon = function ButtonIcon(_ref4) {
  var children = _ref4.children,
      iconSize = _ref4.iconSize,
      other = _objectWithoutProperties(_ref4, _excluded2);

  return /*#__PURE__*/_jsx(StyledButtonIcon, _objectSpread({
    icon: children,
    iconSize: iconSize
  }, other));
};

ButtonIcon.displayName = "ButtonIcon";
ButtonIcon.propTypes = {
  /** Will render icon passed between component tags. Icon should be passed as a component */
  children: PropTypes.node,

  /** Will set size of the icon */
  iconSize: PropTypes.oneOf(Object.values(ICON_SIZE))
};
ButtonIcon.defaultProps = {
  children: undefined,
  iconSize: ICON_SIZE.DEFAULT
};
export { ButtonIcon };